import { useState, useEffect, useRef } from 'react';
import { surveyRepository } from '../data/surveyRepository';

interface UseEnqueteReturn {
  enqueteUrl: string | null;
  isLoading: boolean;
  error: string | null;
}

export const useEnquete = (
  inquiryId: string,
  token?: string
): UseEnqueteReturn => {
  const [enqueteUrl, setEnqueteUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const fetchEnquete = async () => {
      const result = await surveyRepository.getEnqueteUrl(inquiryId, token);
      if (result.success) {
        setEnqueteUrl(result.data.enqueteUrl);
      } else {
        setError(result.error.message);
      }
      setIsLoading(false);
    };

    fetchEnquete();
  }, [inquiryId, token]);

  return { enqueteUrl, isLoading, error };
};
